<template>
  <div class="gl-base-modal">
    <div
      v-if="closable"
      class="gl-base-modal__close"
      @click="$emit('close')"
    >
      <slot name="close-icon">
        <gl-icon
          gray
          :height="16"
          name="I-Close"
          :width="16"
        />
      </slot>
    </div>

    <div
      v-if="$slots.header || title"
      class="gl-base-modal__header"
    >
      <slot name="header">
        <h2 v-if="title">
          {{ title }}
        </h2>
      </slot>
    </div>

    <div class="gl-base-modal__body">
      <slot />
    </div>

    <div
      v-if="$slots.footer"
      class="gl-base-modal__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import GlIcon from '@/components/gl-icon'
export default {
  name: 'GlBaseModal',
  components: {
    GlIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.gl-base-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  background: var(--Background-S1, #fff);
  width: 100%;
}

.gl-base-modal__close {
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  z-index: 2;
}

.gl-base-modal__header {
  padding: 24px 24px 0 24px;
}

.gl-base-modal__body {
  padding: 24px;
  flex: 1;
}

.gl-base-modal__footer {
  padding: 0 24px 24px 24px;
}
</style>
